
import { useI18n } from "vue-i18n";
import { api } from "@/services/Api";
import { computed } from "vue";
import { useStore } from "@/store";

export default {
  async setup() {
    const store = useStore();
    const { locale } = useI18n();

    const currentLanguageImage = computed(() => require(`@/assets/icons/${locale.value}.png`));

    const body = document.querySelector("body");
    const html = document.querySelector("html");
    const changeLang = async (lang: string): Promise<void> => {
      if (lang != locale.value) {
        await api.changeLanguage(lang);
        if (html && body) {
          const dir = lang === "he-IL" ? "rtl" : "ltr";
          body.className = "";
          body?.classList.add(dir);
          body.setAttribute("dir", dir);
          html.setAttribute("lang", lang);
          store.commit("updateLang", lang);
          locale.value = store.getters.currentLanguage;
          window.location.reload();
        }
      }
    };

    return {
      changeLang,
      locale,
      currentLanguageImage,
    };
  },
};
